import React, { Component } from "react";
import Form from "./Form";
import { apiUrl } from "../../../utils/apiUrl";
import { toast } from "../../../utils/helpers";
import { postRequest } from "../../../utils/request";
import { rutaCategoria } from "../../../utils/categorias";

class Edit extends Component {
    state = {
        errors: {}
    };
    editUser = async event => {
        event.preventDefault();


        const data = new FormData(event.target);

        const response = await postRequest(apiUrl(`grupos/${this.props.grupo.id}`), data);



        if (response.success) {
            this.props.getGrupos();
            this.props.toggle();
        }

        if (response.code === 422) {
            // "Una categoría no puede depender de sí misma ni de una de sus
            // subcategorías." llega como mensaje suelto, no como error por campo.
            if (typeof response.data?.message === "string") {
                this.setState({ errors: {} });
                toast(response.data.message, "error");
                return;
            }

            this.setState({ errors: response.data.message });
        }
    };

    deleteGrupo = async (event, grupo) => {
        event.preventDefault();


        const url = `grupos/${grupo}`;

        const response = await postRequest(apiUrl(url), {}, 'delete');



        if (response.success) {
            this.props.getGrupos();
            this.props.toggle();
            toast("Grupo borrado.");
        } else {
            // Incluye el 422 de "categoría con subcategorías o artículos asociados".
            toast(response.data, "error");
        }
    };

    render() {
        const { errors } = this.state;
        const { toggle, grupo, arbol } = this.props;
        return (
            <form method='post' onSubmit={this.editUser}>
                <input type='hidden' name='_method' value='patch' />
                <div className='popup__header'>
                    Editar Grupo
                    {grupo.padre_id && (
                        <small className='d-block'>
                            {rutaCategoria(grupo)}
                        </small>
                    )}
                </div>
                <div className='popup__body'>
                    <Form grupo={grupo} errors={errors} arbol={arbol} />
                </div>
                <div className='popup__footer'>
                    <button
                        type='button'
                        className='btn float-left'
                        onClick={(e) => this.deleteGrupo(e, grupo.id)}>
                        <i className='fas fa-trash-alt'></i>
                    </button>

                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    <button type='submit' className='btn btn-primary'>
                        Guardar
                    </button>
                </div>
            </form>
        );
    }
}

export default Edit;
